<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="headline">确认删除</v-card-title>
      <v-card-text>
        确定要删除行业类型 "{{ item.name }}" 吗？此操作无法撤销。
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn color="red darken-1" text @click="confirmDelete">确认删除</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { typesApi } from '@/api/types'

export default {
  name: 'DeleteCompanyTypeConfirmation',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    async confirmDelete() {
      try {
        await typesApi.deleteIndustryType(this.item.id);
        this.$emit('type-deleted');
        this.close();
        this.$toast.success('公司类型删除成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('删除失败：' + errorMessage);
      }
    }
  }
}
</script> 